/* @ngInject */
export default function LicenseEnrollmentMainCtrl(
  $scope,
  $state,
) {
  class LicenseEnrollmentMainController {
    constructor() {
      this.searchQuery = $state.params.query;

      // Reset the search query if navigating back from org-users-search
      $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
        if (fromState.name !== toState.name && fromState.name.includes('org-users-search')) {
          this.searchQuery = '';
        }
      });
    }

    // eslint-disable-next-line class-methods-use-this
    doSearch(query) {
      if (query === null || query.length === 0) {
        return;
      }

      $state.go('org-users-search', {
        query,
      });
    }
  }

  return new LicenseEnrollmentMainController();
}
